import { PLAYER_RESPAWN_DELAY_MS } from "@mucki/shared";

export interface DeathOverlay {
  /** Driven by the server's dead flag, never predicted locally. */
  update(dead: boolean): void;
  dispose(): void;
}

export function createDeathOverlay(parent: HTMLElement = document.body): DeathOverlay {
  const overlay = document.createElement("div");
  overlay.className = "death-overlay";

  const title = document.createElement("div");
  title.textContent = "Your cat has fainted";

  const countdown = document.createElement("div");
  countdown.className = "death-overlay-countdown";

  overlay.append(title, countdown);
  parent.appendChild(overlay);

  let diedAt = 0;
  let visible = false;
  let timer = 0;

  // The delay is shared config, so the countdown needs no extra synced field.
  const tick = () => {
    const remaining = Math.max(0, PLAYER_RESPAWN_DELAY_MS - (Date.now() - diedAt));
    countdown.textContent = `Respawning in ${(remaining / 1000).toFixed(1)}s`;
  };

  return {
    update: (dead) => {
      if (dead === visible) return;
      visible = dead;
      overlay.classList.toggle("is-visible", dead);

      if (dead) {
        diedAt = Date.now();
        tick();
        timer = window.setInterval(tick, 100);
      } else {
        window.clearInterval(timer);
      }
    },
    dispose: () => {
      window.clearInterval(timer);
      overlay.remove();
    },
  };
}
